import React, { useCallback } from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { useAudioPlayerStreamingContext } from '../../../context/AudioPlayerStreamingProvider';
import { useAudioPlayerStreamingStore } from '../../../hooks/useAudioPlayerStreamingStore';
import { AudioStreamingState } from '../../../state/AudioPlayerStreamingStore';

const i18n = defineMessages({
	// TODO: See if we can update this copy to be more generic or add logic to handle different audio types
	buttonText: {
		id: 'audio.audio-player.restart-audio-button',
		defaultMessage: 'Re-start briefing',
		description: 'Text for a button that regenerates audio and plays it when clicked',
	},
});

const styles = cssMap({
	buttonWrapper: {
		marginTop: token('space.100'),
	},
});

export const RestartAudioButton = () => {
	const { fetchAudio } = useAudioPlayerStreamingContext();
	const { state: streamingState } = useAudioPlayerStreamingStore();

	const isLoading = streamingState.state === AudioStreamingState.LOADING;

	const { formatMessage } = useIntl();

	const startNewAudio = useCallback(() => {
		fetchAudio();
	}, [fetchAudio]);

	const handleClick = useCallback(() => {
		// TODO: Add stopExistingAudio method
		// Currently blocked without access to audioRef
		startNewAudio();
	}, [startNewAudio]);

	return (
		<Box xcss={styles.buttonWrapper}>
			<Button
				testId="restart-audio-button"
				shouldFitContainer
				appearance="primary"
				onClick={handleClick}
				isLoading={isLoading}
			>
				{formatMessage(i18n.buttonText)}
			</Button>
		</Box>
	);
};
